import { createContext } from 'react';
import type { EventLeaf } from '@immo/api-contract';

export type WorkspaceEventsContextValue = {
  readonly connected: boolean;
  /** Registers `handler` under `leaf.type`; returns the deregistration. */
  readonly subscribe: (leaf: EventLeaf, handler: (payload: unknown) => void) => () => void;
  /** Registers a refetch signal fired on every reconnect after registration. */
  readonly subscribeReconnect: (handler: () => void) => () => void;
};

/**
 * `null` when no provider is mounted. The hooks then degrade to inert no-ops
 * rather than throwing: a best-effort transport must never be able to break a
 * surface that renders perfectly well without it (ADR 0036).
 */
export const WorkspaceEventsContext = createContext<WorkspaceEventsContextValue | null>(null);
